import { type FC } from 'react'
import { Box, type SxProps, type Theme } from '@mui/material'
import { Form as FormikForm, type FormikFormProps } from 'formik'
import { useScrollInputIntoView } from '@dhl/receiver-page'
import { useScrollToFirstError } from '~/hooks/useScrollToFirstError.js'

type FormProps = FormikFormProps & {
  sx?: SxProps<Theme>
  'data-testid'?: string
}

export const Form: FC<FormProps> = ({ sx, ...formProps }) => {
  const scrollRef = useScrollInputIntoView()
  useScrollToFirstError()

  return (
    <Box ref={scrollRef} sx={sx}>
      <FormikForm noValidate autoComplete="off" {...formProps} />
    </Box>
  )
}
